import { render, staticRenderFns } from "./stock_returns.vue?vue&type=template&id=22392ba4"
import script from "./stock_returns.vue?vue&type=script&lang=js"
export * from "./stock_returns.vue?vue&type=script&lang=js"
import style0 from "./stock_returns.vue?vue&type=style&index=0&id=22392ba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports